// The Invite Friends screen has no Figma frame of its own yet: the Notion spec's preview gives the
// layout, and every colour, radius and stroke comes from the friends modal's tokens
// (`friendsTheme`, read off "Friends / Mobile — Modal" 4244:41053) so it reads as the same modal.
// The few values below are the ones that screen has no counterpart for, each picked from a token
// the file already uses.
import { friendsColors } from '../friendsTheme';

/** The gold CTA ramp - gold/300 into border/gold, the same pair the level badge and action outlines use. */
export const CLAIM_FILL: Array<[string, string]> = [
	['0', '#FFE14D'],
	['1', friendsColors.gold300],
];
/** text/on-gold. */
export const CLAIM_TEXT = friendsColors.onGold;

/** The progress bar: gold while a friend is levelling, progress-bar-level-green once complete. */
export const PROGRESS_FILL = {
	progress: [
		['0', friendsColors.inGame],
		['1', friendsColors.borderGold],
	] as Array<[string, string]>,
	complete: [
		['0', '#6FE07A'],
		['1', friendsColors.online],
	] as Array<[string, string]>,
};
/** surface/sunken. */
export const PROGRESS_TRACK = friendsColors.surfaceSunken;

/** The hero's warm wash, from the modal scrim's red into the raised surface. */
export const HERO_FILL: Array<[string, string]> = [
	['0', '#5C1408'],
	['1', friendsColors.surface],
];
